module.exports = new __parcel__URL__("user.78640def.jpeg").toString();